/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraProject {
    getFixupPrototypeFunction() { return JiraProject.fixupPrototype; }

    static newInstance(model: Partial<JiraProject>): JiraProject {
        let obj = Object.assign(new JiraProject(), model);
        JiraProject.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraProject>): JiraProject {
        if (!model) return null;
        return JiraProject.newInstance(<JiraProject> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraProject) {
        if (!obj) return;

        models.JiraProject.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraProject): boolean {
        Object.setPrototypeOf(obj, JiraProject.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the project
     */
    name: string;

    /**
     * Key of the project
     */
    key: string;

    /**
     * ID of the project
     */
    item_id: string;

    /**
     * URL of the project
     */
    url: string;

}
